import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import {ReactComponent as Frame2} from "../../assets/images/Frame2.svg"
import {ReactComponent as Frame3} from "../../assets/images/Frame3.svg"
 
const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  ...restProps
}) => {
  return (
    <button
      className={`flex flex-col w-[158px] text-[#54af3a] h-14 items-center justify-center gap-2.5 px-4 py-[18px] relative bg-[#f3fcf3] tracking-[0] leading-5 rounded-full overflow-hidden border-1 border-solid border-dark_green-100 hover:bg-[#e1f8e1] hover:border-green-500 transition-all duration-300 ${className}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};
 
Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
};
 
const SubmitButton = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  override,
  ...restProps
}) => {
  return (
    // relative flex items-center justify-center w-full bg-navy-700 h-12 px-[30px] py-0 rounded-2xl overflow-hidden shadow-[inset_0px_-4px_4px_#00000040] hover:bg-navy-100 transition-colors duration-300 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:focus:outline-none
    <button className={`${!override ? "text-white h-10 cursor-pointer bg-gradient-to-r from-navy-500 via-navy-600 to-navy-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-navy-300 dark:focus:ring-navy-800 shadow-sm shadow-navy-500/50 dark:shadow-sm dark:shadow-navy-800/80 font-medium rounded-lg text-sm px-3 py-1 text-center me-1 mb-1 disabled:cursor-not-allowed disabled:opacity-50 disabled:focus:outline-none" : ""} ${className}`} {...restProps}>
 
      {!!leftIcon && leftIcon}
      <span className="font-semibold text-[#ffffff] text-base tracking-[0] leading-6 whitespace-nowrap">
        {children}
      </span>
      {!!rightIcon && rightIcon}
    </button>
  );
};
 
SubmitButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  override: PropTypes.bool,
};
 
// const UpButton = ({
//   children,
//   className = "",
//   leftIcon,
//   rightIcon,
//   ...restProps
// }) => {
//   return (
//     <button className={`flex flex-col w-[158px] text-[#54af3a] h-14 items-center justify-center gap-2.5 px-4 py-[18px] relative bg-[#f3fcf3] tracking-[0] leading-5 rounded-full overflow-hidden border-1 border-solid border-dark_green-100 hover:bg-[#e1f8e1] hover:border-green-500 transition-all duration-300 ${className}`} {...restProps}>
//       {!!leftIcon && leftIcon}
//       {children}
//       {!!rightIcon && rightIcon}
//     </button>
//   );
// };
 
const isValidFileSize = (file, maxSizeInMB) => {
  const maxSize = maxSizeInMB * 1024 * 1024; // Convert MB to bytes
  return file.size <= maxSize;
};
 
const isValidFileType = (file, validTypes) => {
  return validTypes.includes(file.type);
};
 
const UpButton = forwardRef(
  (
    {
      children,
      className = "",
      leftIcon,
      rightIcon,
      maxFileSizeMB = 5,
      validFileTypes = ["image/jpeg", "image/png", "application/pdf"],
    //   apiCallHandler,
      onFileChange,
      ...restProps
    },
    ref
  ) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [fileName, setFileName] = useState({ name: "" });
 
    const fileInputRef = React.createRef();
 
    useImperativeHandle(ref, () => ({
      getFileInput: () => fileInputRef.current,
      clearFile: () => (fileInputRef.current.value = ""),
    }));
 
    const handleFileChange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;
 
      if (!isValidFileSize(file, maxFileSizeMB)) {
        setErrorMessage(`File size should not exceed ${maxFileSizeMB}MB`);
        return;
      }
 
      if (!isValidFileType(file, validFileTypes)) {
        setErrorMessage("Invalid file type. Please upload a valid image.");
        return;
      }
 
      setErrorMessage(null);
      setFileName(file.name);
 
      if (onFileChange) {
        onFileChange(file);
      }
 
    //   if (apiCallHandler) {
    //     setIsUploading(true);
    //     try {
    //       await apiCallHandler(file);
    //       setFileName((prev) => ({ ...prev, name: file.name }));
    //       setIsUploading(false);
    //     } catch (error) {
    //       setErrorMessage("File upload failed. Please try again.");
    //       setIsUploading(false);
    //     }
    //   }
    };
 
    const handleFileInputRef = () => {
      fileInputRef && fileInputRef.current.onClick();
    };
 
    // const handleRemoveFile = () => {
    //   e.stopPropagation();
    //   setFileName(null);
    //   if (ref?.current) {
    //     ref.current.value = "";
    //   }
    // };
 
    const FileView = () => {
      return <div className="pb-4">
      <div className="d-flex justify-content-end align-items-start">
        <Button type="button" color="link">
          {/* <img src="../../assets/images/Frame2.svg" alt="button icon" /> */}
          <Frame2/>
        </Button>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center gap-2">
        <div>
          {/* <img src="../../assets/images/Frame3.svg" alt="icon" /> */}
          <Frame3/>
        </div>
        <p>{fileName.name}</p>
      </div>
    </div>;
    
      
      
    //   <div className="pb-4">
    //   <div className="flex flex-row justify-end items-start">
    //   <button type="button"><img src="/images/Frame (3).svg"/></button>
    //   </div>
    //   <div className="flex flex-col justify-center items-center gap-2">
    //   <div><img src="/images/Frame (2).svg"/></div>
    //   <p>{fileName.name}</p>
    //   </div>
     
    //   </div>;
    };
 
    return (
      <div className={`relative !cursor-pointer ${className}`}>
        <button
          className={`flex flex-col w-[165px] h-32 items-center justify-center gap-1 px-4 py-2 bg-[#f6fbff] rounded-[18px] overflow-hidden border-2 border-dashed border-[#1B6FED] text-[#53627c] text-[13px] hover:bg-[#eef6ff] transition-all duration-300 ${className}`}
          onClick={handleFileInputRef}
          {...restProps}
        >
          {!!leftIcon && leftIcon}
 
          {isUploading ? (
            <div className="text-blue-500 text-xs mt-2">Uploading...</div>
          ) : fileName.name ? (
            <div className={`mt-2 w-[150px] text-[10px]`}>{<FileView />}</div>
          ) : (
            children
          )}
          {!!rightIcon && rightIcon}
        </button>
        <input
          type="file"
          id="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="absolute top-0 left-0 w-full h-full opacity-0 !cursor-pointer"
        />
        {errorMessage && (
          <div className="text-red-500 text-xs mt-2">{errorMessage}</div>
        )}
      </div>
    );
  }
);
 
UpButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  maxFileSizeMB: PropTypes.number,
  validFileTypes: PropTypes.array,
//   apiCallHandler: PropTypes.func,
  onFileChange: PropTypes.func,
};
 
export { Button, SubmitButton, UpButton };